import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursAbcAbout() {
  return <section className="py-20 lg:py-32 bg-brand-cream relative overflow-hidden" data-id="element-821">
      <div className="max-w-7xl mx-auto px-6" data-id="element-822">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="lg:hidden mb-10 text-center" data-id="element-823">
          <SectionHeading title="Cine sunt eu și de ce am creat cursul ABC-ul Prosperității" centered={true} data-id="element-824" />
        </motion.div>

        <div className="grid lg:grid-cols-[2fr_3fr] gap-12 lg:gap-20 items-stretch" data-id="element-825">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full max-w-[400px] mx-auto lg:mx-0 lg:max-w-none aspect-[3/4] lg:aspect-auto lg:min-h-full" data-id="element-826">
            <div className="hidden lg:block absolute -top-6 -left-6 w-24 h-24 border-[1.5px] border-brand-gold/30 rounded-full pointer-events-none" data-id="element-827" />
            <div className="hidden lg:block absolute -bottom-6 -right-6 w-32 h-32 border border-brand-gold/25 rounded-full pointer-events-none" data-id="element-828" />
            <div className="hidden lg:block absolute -top-3 -right-3 w-2.5 h-2.5 bg-brand-gold/70 rotate-45 pointer-events-none" data-id="element-829" />

            <div className="absolute inset-0 rounded-[32px] overflow-hidden shadow-warm" data-id="element-830">
              <img src="https://cdn.magicpatterns.com/uploads/hbWtuJ6aCvHUuJajw2QL9A/Screenshot_2026-05-15_at_21.29.02.png" alt="Adrian Huniade" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-831" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-832">
            <div className="hidden lg:block" data-id="element-833">
              <SectionHeading title="Cine sunt eu și de ce am creat cursul ABC-ul Prosperității" centered={false} data-id="element-834" />
            </div>

            <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed mb-10" data-id="element-835">
              <p data-id="element-836">
                Sunt <strong data-id="element-837">Adrian Huniade</strong>, Instructor Internațional
                Theta Healing® și Facilitator Heal Your Life, cu peste 25 de
                ani de experiență în terapii complementare și dezvoltare
                personală.
              </p>
              <p data-id="element-838">
                Am creat cursul ABC-ul Prosperității pentru că am văzut același
                tipar de sute de ori: oameni care muncesc mult, care sunt
                capabili, care au potențial, dar care se lovesc mereu de un
                plafon invizibil. Și de fiecare dată când am săpat mai adânc, am
                găsit același lucru: credințe limitative în subconștient care le
                spuneau că nu pot, că nu merită, că e greu.
              </p>
              <p data-id="element-839">
                Acest curs aduce laolaltă tehnici din Theta Healing®, metoda
                Louise Hay și exerciții practice pe care le-am testat cu
                cursanți din toată România și din diaspora. Nu e teorie
                abstractă. E un proces structurat prin care îți schimbi gândirea
                și îți clarifici direcția.
              </p>

              <p className="text-xl md:text-2xl font-subtitle text-brand-purple font-medium py-4" data-id="element-840">
                Iar harta comorilor pe care o creezi aici devine instrumentul
                tău zilnic de navigare către viața pe care ți-o dorești.
              </p>

              <div className="p-6 bg-brand-purple/5 border-l-4 border-brand-purple rounded-r-xl" data-id="element-841">
                <p className="font-subtitle italic text-xl text-brand-text" data-id="element-842">
                  "Predau simplu, clar și structurat, cu multă iubire. Iar
                  cursanții mei spun că simt această iubire și că schimbarea
                  vine natural."
                </p>
              </div>
            </div>

            <CTAButton className="items-start" data-id="element-843" />
          </motion.div>
        </div>
      </div>
    </section>;
}